import types  from './types';

export const accessGranted = ({username,idClient,access_configuration,channel,first}) =>{
    return{
        type:types.accessGranted,
        username,
        idClient,
        access_configuration,
        channel,
        first
    }
}

export const logout =  () =>{

    return{
        type:types.logout
    }
}
